var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.394,
    height: 17.394,
    viewBox: "0 0 17.394 17.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1454",
    "data-name": "Group 1454",
    transform: "translate(-409.803 -229.803)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x2: 14,
    y2: 14,
    transform: "translate(411.5 231.5)",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x1: 14,
    y2: 14,
    transform: "translate(411.5 231.5)",
    fill: "none",
    stroke: "#474747",
    strokeLinecap: "round",
    strokeWidth: 2.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.7b42c52be0b26de39ea447e1be761ac1.svg";
export { ForwardRef as ReactComponent };